import * as React from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Autocomplete, {
  AutocompleteInputChangeReason,
} from "@material-ui/lab/Autocomplete";
import { searchExternalArtists } from "../../../../../sdk/artists";
import { ArtistSearchResult } from "../../../../../../../../services/artist/types/artist-search-result";
import {
  Checkbox,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  IconButton,
  Input,
} from "@material-ui/core";

interface AddCollaboratorDialogProps {
  isOpen: boolean;
  roles: string[];
  title: string;
  onClose: () => void;
  onAddCollaborator: (
    artistData: ArtistSearchResult | string,
    role: string
  ) => void;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export const AddCollaboratorDialog: React.FC<AddCollaboratorDialogProps> = (
  props
) => {
  const [options, setOptions] = React.useState<ArtistSearchResult[]>([]);
  const [selectedArtist, setSelectedArtist] = React.useState<
    ArtistSearchResult | string | null
  >();
  const [role, setRole] = React.useState<string>("");

  const onInputChange = (
    _event: React.ChangeEvent<{}>,
    value: string,
    _reason: AutocompleteInputChangeReason
  ) => {
    if (value.length > 2) {
      searchExternalArtists(value).then((res) => {
        setOptions(res.spotify);
      });
    }
  };

  return (
    <Dialog
      open={props.isOpen}
      onClose={props.onClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogContent>
        <DialogContentText>{`Add ${props.title} to Track`}</DialogContentText>
        {props.title === "Collaborator" ? (
          <Autocomplete
            id="artist-select"
            options={options}
            onInputChange={onInputChange}
            getOptionLabel={(option) => option.name}
            style={{ width: 400 }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select an artist"
                variant="outlined"
              />
            )}
            renderOption={(option) => (
              <React.Fragment>
                <IconButton color="primary">
                  <img
                    src={option.avatar}
                    height={40}
                    width={40}
                    style={{ borderRadius: 40 }}
                    alt={option.name}
                  />
                </IconButton>
                {option.name}
              </React.Fragment>
            )}
            onChange={(_event, value, _reason) => setSelectedArtist(value)}
          />
        ) : (
          <Input
            type={"text"}
            onChange={(ev) => setSelectedArtist(ev.target.value)}
          ></Input>
        )}
        <InputLabel id="role_label">Role</InputLabel>
        <Select
          labelId="role_label"
          id="collaborator_role"
          multiple={false}
          value={role}
          onChange={(event) => {
            setRole(event.target.value as unknown as string);
          }}
          input={<OutlinedInput label="Role" />}
          MenuProps={MenuProps}
        >
          {props.roles.map((r) => (
            <MenuItem key={r} value={r}>
              <Checkbox checked={role.indexOf(r) > -1} />
              <ListItemText primary={r} />
            </MenuItem>
          ))}
        </Select>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} color="primary">
          Cancel
        </Button>
        <Button
          onClick={() => {
            if (selectedArtist) {
              props.onAddCollaborator(selectedArtist, role);
            }
          }}
          color="default"
        >
          {`Add ${props.title}`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
